<template>
  <div class="flex flex-col items-center justify-center cursor-pointer p-2" :class="'bg-success ' + size"
    @click="focus()">
    <svg class="fill-current" width="21.215" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 217.39 273.16">
      <path
        d="M169.02,234.47H23.33c-13.09,0-23.33,10.24-23.33,23.33v15.37h192.35v-15.37c0-13.09-10.81-23.33-23.33-23.33Z" />
      <path
        d="M217.39,27.32c0-15.37-11.95-27.32-27.32-27.32-11.38,0-21.06,6.83-25.04,17.07l-69.43,22.19-29.02-29.02c-37.56,38.7-37.56,100.73,1.14,139.43,2.28,2.28,4.55,4.55,7.4,6.83l-29.59,59.19h100.73l-18.21-36.99c28.45,2.85,57.48-6.26,79.67-27.89l-29.02-29.02,22.19-68.86c9.67-4.55,16.5-14.23,16.5-25.61ZM169.59,112.68L104.71,47.8l58.05-18.78c1.14,13.09,11.38,23.9,24.47,25.04l-17.64,58.62Z" />
    </svg>
    <span class="text-center text-balance leading-3 mt-3">
      {{ config.deviceFamilly.this_name }}
    </span>
  </div>
</template>

<script>
import { droneStateColor } from "@/utils/Utils.js"

export default {
  props: {
    config: Object,
    size: String,
  },
  computed: {

  },
  methods: {
    focus() {
      this.config.drone.methods.ShowTheDrone();
    },
  },
};
</script>
